import { skNativeContainer } from '@/api/native/container';
import { PageThemeTypeEnum } from '@/enums/pageThemeType';
import { RouterV2Enum } from '@/router/router-names';

/**
 * 首页广告位ID
 * 通过广告投放系统配置： https://fat-admaster.hellobike.cn/#/ssp/operation-mng
 */
export const HOME_ADV_ID_MAP = {
  /**
   * 名称: 数科-臻有钱首页-臻有钱首页营销位
   * uid: ae615a4b817d4f4882bd778df453031b
   */
  FINANCE_CARD_ADV_BANNER: 'ae615a4b817d4f4882bd778df453031b',
  /**
   * 名称:数科-臻有钱首页-首页挽留弹窗
   * uuid: 07b91a7c0e544f0681d42b56e5ae51f8
   */
  BACK_POPUP: '07b91a7c0e544f0681d42b56e5ae51f8',
  /**
   * 名称: 数科-臻有钱首页-按钮角标
   * uuid: 44b816310e4842ecaafc974722cc7f0a
   */
  ACTION_BTN_CORNER: '44b816310e4842ecaafc974722cc7f0a',

};

/** ubt埋点参数首页标识 */
export const UBT_COMMON_HOME_PAGE_SIGN = 'newHomePage';

/** 进入新版首页v3/home 的主题类型 */
export const HomeV3PageThemeList = [
  PageThemeTypeEnum.ORANGE_THEME,
  PageThemeTypeEnum.BLUE_THEME,
  // PageThemeTypeEnum.DEFAULT,
];

/** 旧版首页v2/home 的路由列表，需要各类兼容处理 */
export const OLD_HOME_ROUTE_PATHS = [
  RouterV2Enum.home,
  RouterV2Enum.taglessHome,
  RouterV2Enum.qualityHomePage,
];

/** 数科容器化Webview容器首页tabId */
export const SK_NATIVE_CONTAINER_HOME_TABID = 'home';
